/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {HelpIcon} from "../HelpIcon";
import {RemoveItemButton} from "./Buttons/RemoveItemButton";

export function RemoveConservationActionPermitItemButton(props) {
    const {
        item,
        show = true
    } = props;
    
    if(item.isAssigned) {
        return <div className="remove-table pop-remove">
            <HelpIcon id={"help-icon-" + item.conservationActionId}>
                This Conservation Action is assigned from the Permits Survey page. To remove it, click on the
                Conservation Action name and remove it from the corresponding section in the Survey.
            </HelpIcon>
        </div>
    }
    
    return <RemoveItemButton {...props} />;
}
